import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '@/components/Footer';
import LegalDraftNotice from '@/components/LegalDraftNotice';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex flex-col">
      <main className="flex-1 max-w-3xl mx-auto px-6 py-16 w-full" data-testid="disclaimer-page">
        <LegalDraftNotice docName="Disclaimer" />
        <h1 className="text-3xl font-bold mb-6">Disclaimer</h1>
        <div className="space-y-4 text-muted-foreground">
          <p>Insul Nutrients provides AI-generated nutritional estimates for general informational purposes only. It is not a medical device and does not provide medical advice, diagnosis, or treatment.</p>
          <p>Always seek the advice of a qualified health professional with any questions regarding a medical condition or dietary requirements.</p>
        </div>
        <Link to="/" className="inline-block mt-8 text-primary font-semibold">← Back to home</Link>
      </main>
      <Footer />
    </div>
  );
}
